// useAnalytics.js
import { getAnalytics, logEvent, setUserId } from 'firebase/analytics'
import { useContext } from 'react'
import { TenantsContext } from '../context/tenants.context'
import { LocalContext } from '../pages/AdminLocal/context/local.context'

export const useAnalytics = () => {
  const { tenant } = useContext(TenantsContext)
  const { local, codLocal } = useContext(LocalContext)
  const track = (eventName, params = {}) => {
    try {
      const analytics = getAnalytics()
      // platform/tenant + cod_local/item_brand (= nombre del local) van automáticos en cada evento.
      // Si el call site pasa cod_local o item_brand en `params`, prevalece el override del call site.
      logEvent(analytics, eventName, {
        ...params,
        cod_local: codLocal,
        item_brand: local?.nombre,
        platform: 'web',
        tenant: tenant.path
      })
    } catch (error) {
      console.error('Error logging Firebase Analytics event:', error)
    }
  }
  const setUser = (userId) => {
    try {
      const analytics = getAnalytics()
      setUserId(analytics, userId.toString())
    } catch (error) {
      console.error('Error setting Firebase Analytics user ID:', error)
    }
  }

  return { track, setUser }
}
